import { useFetch } from './useFetch';

/**
 * Get section rendering html query result
 * @param {String} base - url query
 * @param {String} section - name section id
 * @param {String} params - optional params '?section_id'
 * @returns query response HTML
 */
export const sectionAPI = async (base, section, params = '&section_id=') =>
  await useFetch(base + params + section);
